var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "proofreading-select-checks" }, [
    _c("h1", { staticClass: "proofreading-select-checks__heading" }, [
      _vm._v(
        " " + _vm._s(_vm.$t("proofreadingSelectChecksPage.heading")) + " "
      ),
    ]),
    _c(
      "div",
      {
        staticClass: "proofreading-select-checks__list",
        attrs: { role: "radiogroup" },
      },
      _vm._l(_vm.checkIds, function (checkId, index) {
        return _c(
          "div",
          {
            key: checkId,
            staticClass: "check-row",
            class: [
              _vm.rowSurfaceClass(index),
              { "check-row--disabled": !_vm.isCheckSelectable(checkId) },
            ],
            attrs: {
              role: "radio",
              "aria-checked": _vm.isCheckEnabled(checkId),
              "aria-disabled": !_vm.isCheckSelectable(checkId),
            },
            on: {
              click: function ($event) {
                return _vm.onSelectCheck(checkId)
              },
            },
          },
          [
            _c(
              "span",
              {
                staticClass: "check-row__radio",
                attrs: { "data-disabled": !_vm.isCheckSelectable(checkId) },
              },
              [
                _c("RadioIcon", {
                  attrs: {
                    value: checkId,
                    selected: _vm.selectedCheckId,
                    fill: _vm.checkboxFill(_vm.isCheckEnabled(checkId)),
                  },
                }),
              ],
              1
            ),
            _c("span", { staticClass: "check-row__label" }, [
              _vm._v(_vm._s(_vm.$t(_vm.checkMeta(checkId).labelKey))),
            ]),
            _c(
              "button",
              {
                staticClass: "check-row__info-button",
                attrs: {
                  type: "button",
                  "aria-label": _vm.$t(
                    "proofreadingItemSelectDialog.showRuleDescription",
                    {
                      label: _vm.$t(_vm.checkMeta(checkId).labelKey),
                    }
                  ),
                  disabled: _vm.isSubmitting,
                },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.onClickRuleInfo(checkId)
                  },
                },
              },
              [_c("IconInfo")],
              1
            ),
          ]
        )
      }),
      0
    ),
    _vm.checkWarnings.length > 0
      ? _c(
          "div",
          { staticClass: "proofreading-select-checks__warnings" },
          _vm._l(_vm.checkWarnings, function (warning) {
            return _c(
              "p",
              { key: warning.id, staticClass: "check-warning" },
              [
                _c("span", { staticClass: "check-warning__text" }, [
                  _vm._v(_vm._s(_vm.$t(warning.messageKey))),
                ]),
                warning.action === "theme" && _vm.novelId
                  ? _c(
                      "router-link",
                      {
                        staticClass: "check-warning__link",
                        attrs: {
                          to: {
                            name: "theme",
                            params: { novelId: _vm.novelId },
                          },
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("proofreadingSelectChecksPage.themeLink")
                            ) +
                            " "
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            )
          }),
          0
        )
      : _vm._e(),
    _c("div", { staticClass: "proofreading-select-checks__estimate" }, [
      _c(
        "p",
        { staticClass: "estimate-main" },
        [
          _vm.enabledCheckCount > 0
            ? _c(
                "i18n",
                {
                  attrs: {
                    path: "proofreadingSelectChecksPage.estimateWithBreakdown",
                    tag: "span",
                  },
                },
                [
                  _c(
                    "strong",
                    {
                      staticClass: "estimate-amount",
                      attrs: { place: "amount" },
                    },
                    [_vm._v(_vm._s(_vm.formattedEstimatedFish) + " fish")]
                  ),
                  _c("span", { attrs: { place: "chars" } }, [
                    _vm._v(_vm._s(_vm.formattedTotalChars)),
                  ]),
                  _c("span", { attrs: { place: "rate" } }, [
                    _vm._v(_vm._s(_vm.fishPerChar)),
                  ]),
                ]
              )
            : _c(
                "i18n",
                {
                  attrs: {
                    path: "proofreadingSelectChecksPage.estimate",
                    tag: "span",
                  },
                },
                [
                  _c(
                    "strong",
                    {
                      staticClass: "estimate-amount",
                      attrs: { place: "amount" },
                    },
                    [_vm._v(_vm._s(_vm.formattedEstimatedFish) + " fish")]
                  ),
                ]
              ),
        ],
        1
      ),
      _vm.isFishInsufficient
        ? _c("div", { staticClass: "fish-warning" }, [
            _c("p", { staticClass: "fish-warning__message" }, [
              _vm._v(
                _vm._s(_vm.$t("proofreadingSelectChecksPage.fishInsufficient"))
              ),
            ]),
          ])
        : _vm._e(),
    ]),
    _c("footer", { staticClass: "proofreading-select-checks__footer" }, [
      _c(
        "button",
        {
          staticClass: "proofreading-select-checks__back-button",
          attrs: { type: "button", disabled: _vm.isSubmitting },
          on: { click: _vm.onClickBack },
        },
        [
          _vm._v(
            " " + _vm._s(_vm.$t("proofreadingSelectChecksPage.back")) + " "
          ),
        ]
      ),
      _c(
        "button",
        {
          staticClass: "proofreading-select-checks__run-button",
          attrs: { type: "button", disabled: !_vm.canProceed },
          on: { click: _vm.onClickNext },
        },
        [
          _vm._v(
            " " +
              _vm._s(
                _vm.isSubmitting
                  ? _vm.$t("proofreadingSelectChecksPage.submitting")
                  : _vm.$t("proofreadingSelectChecksPage.runProofreading")
              ) +
              " "
          ),
        ]
      ),
    ]),
    _c("div", { staticClass: "proofreading-select-checks__notice" }, [
      _c("p", { staticClass: "notice-text" }, [
        _vm._v(_vm._s(_vm.$t("proofreadingSelectChecksPage.noticeIssueLimit"))),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }